import React from 'react';
import QuizTemplate from './QuizTemplate';

function QuizIntroCreativity({pb}) {
   const questions = [
      {
        questionText: 'What are the two components of creativity?',
        answerOptions: [
          { answerText: 'Originality and Novelty', isCorrect: false },
          { answerText: 'Novelty and Usefulness', isCorrect: true },
          { answerText: 'Out-of-box thinking and Novelty', isCorrect: false },
        ],
      },
      {
        questionText: 'Which careers need creativity?',
        answerOptions: [
          { answerText: 'Artist', isCorrect: false },
          { answerText: 'Scientist', isCorrect: false },
          { answerText: 'Mathematician', isCorrect: false },
          { answerText: 'All of the above', isCorrect: true },
        ],
      },
    ]

    return(
      <div className="m-3">
         <QuizTemplate data={questions} problem={pb} />
      </div>
    )

}

export default QuizIntroCreativity;